import React, { useEffect, useState } from 'react'

import { convertUTCtoMSK } from '../../../../../../utils'
import { getRevisions } from '../core/api'
import { DepositCancelReasonRevision } from '../core/response.types'

const PER_PAGE = 20

interface Props {
  /** Bumped by the page after every save, so the newest revision appears without a reload. */
  reloadKey: number
}

export const RevisionHistory: React.FC<Props> = ({ reloadKey }) => {
  const [items, setItems] = useState<DepositCancelReasonRevision[]>([])
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)

  useEffect(() => {
    getRevisions(page, PER_PAGE)
      .then((r) => {
        if (r.data.success) {
          setItems(r.data.data ?? [])
          setTotal(r.data.totalRows ?? 0)
        }
      })
      .catch(() => undefined)
  }, [page, reloadKey])

  const pages = Math.max(1, Math.ceil(total / PER_PAGE))

  return (
    <div className='card mt-5'>
      <div className='card-header'>
        <h3 className='card-title'>История изменений</h3>
      </div>
      <div className='card-body'>
        {items.length === 0 ? (
          <div className='text-muted'>Записей нет</div>
        ) : (
          <table className='table table-row-dashed align-middle'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th style={{ width: 170 }}>Когда</th>
                <th style={{ width: 160 }}>Кто</th>
                <th>Набор после изменения</th>
              </tr>
            </thead>
            <tbody>
              {items.map((rev) => (
                <tr key={rev.id}>
                  <td>{convertUTCtoMSK(rev.createdAt)}</td>
                  <td>{rev.author ?? 'Начальный набор'}</td>
                  <td data-testid={`revision-set-${rev.id}`}>
                    {rev.items.map((item, index) => (
                      <div key={item.id} className={item.enabled ? '' : 'text-muted'}>
                        {index + 1}. {item.title} ({item.code}){item.enabled ? '' : ' — выключена'}
                      </div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {pages > 1 && (
          <div className='d-flex gap-2 justify-content-end'>
            <button
              type='button'
              className='btn btn-sm btn-light'
              disabled={page <= 1}
              onClick={() => setPage(page - 1)}
            >
              Назад
            </button>
            <span className='align-self-center'>
              {page} / {pages}
            </span>
            <button
              type='button'
              className='btn btn-sm btn-light'
              disabled={page >= pages}
              onClick={() => setPage(page + 1)}
            >
              Вперёд
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default RevisionHistory
